import { render } from "./CreateBill.vue?vue&type=template&id=5d64e807&scoped=true&ts=true"
import script from "./CreateBill.vue?vue&type=script&lang=ts"
export * from "./CreateBill.vue?vue&type=script&lang=ts"

import "./CreateBill.vue?vue&type=style&index=0&id=5d64e807&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d64e807"]])

export default __exports__